import { getById } from './get-by-id';
import { getEnabled } from './get-enabled';

const institutionAdapter = {
  getEnabled,
  getById
};

export { institutionAdapter };
